import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function ArticleList() {
  const latestArticles = getLatestArticles(12);

  return (
    <section className="py-14 bg-background-50">
      <div className="container-main">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新爆料
            </h2>
            <p className="mt-2 text-sm text-foreground-500">实时更新，不错过任何一个内幕</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latestArticles.map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block rounded-lg bg-background-100 hover:bg-background-200/60 transition-all duration-300 overflow-hidden animate-fade-in-up"
              style={{ animationDelay: `${idx * 50}ms` }}
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.imageCard}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3 flex items-center gap-1.5">
                  {article.isExclusive && (
                    <span className="px-2 py-0.5 text-[10px] font-medium rounded bg-accent-500/90 text-white">
                      独家
                    </span>
                  )}
                  {article.isHot && (
                    <span className="px-2 py-0.5 text-[10px] font-medium rounded bg-primary-500/90 text-white">
                      热门
                    </span>
                  )}
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-[10px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-[10px] text-foreground-400">{article.publishDate}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-200/50">
                  <div className="flex items-center gap-1 text-[10px] text-foreground-400">
                    {article.authorVerified && (
                      <i className="ri-verified-badge-fill text-primary-400 text-xs"></i>
                    )}
                    <span>{article.author}</span>
                  </div>
                  <div className="flex items-center gap-3 text-[10px] text-foreground-400">
                    <span className="flex items-center gap-0.5">
                      <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                    </span>
                    <span className="flex items-center gap-0.5">
                      <i className="ri-chat-3-line"></i> {article.comments}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/entertainment"
            className="inline-flex items-center gap-2 px-8 py-3 text-sm font-medium rounded-full bg-background-100 text-foreground-700 hover:bg-background-200 transition-colors duration-200 whitespace-nowrap"
          >
            加载更多爆料
            <i className="ri-arrow-down-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}